import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostBinding, OnInit } from '@angular/core';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImgDirective } from 'src/layout/media/directives/img.directive';
import { ImageMapper } from 'src/layout/media/image-loader';

// tslint:disable: no-string-literal

// export interface AmountWithUnit {
//     amount: string | number;
//     unit: string;
// }

export interface BoxSettings {
    id?: string;
    maxWidth: string;
    margin: string;
    padding: string;
    wrap: boolean;
    disallowWrap: boolean;
    aspectRatio: string;
    hideAt?: string;
}

export interface ColorSettings {
    colorTheme?: {
        color: string;
        backgroundColor: string;
    }
}

export interface FontSettings {
    // primaryFont: string;
    // secondaryFont: string;
    // baseFont: string;
}

export interface ColumnSettings {
    columnCount: number;
    columnGap: string;
    columnWidth: string;
}

export interface PositionSettings {
    position?: string;
}

export type SourceSet = {
    alias: string,
    imageBreakSize: string
    img: UmbracoImage;

}

export interface BackgroundSettings {
    backgroundImage?: UmbracoImage;
    backgroundImageMobile?: UmbracoImage;
    parallax?: boolean;
}

export type GeneralElementSettings =
    Partial<BoxSettings> &
    Partial<ColorSettings> &
    Partial<FontSettings> &
    Partial<PositionSettings> &
    Partial<ColumnSettings> &
    Partial<BackgroundSettings>;


@Directive()
export class SettingsSetterDirective implements AfterViewInit, OnInit {
    static hideAt = {
        "x<500": '',
        "x<1024": '',
        "x>=500": '',
        "x>=1024": '',
    }
    static mapSourceSet(arg0: BackgroundSettings): string {
        if (arg0 == null || arg0?.backgroundImage == null)
            return
        let backgroundImageUrl = new URL(arg0?.backgroundImage?.imageUrl, globalThis.location.origin);
        let backgroundImageMobileUrl = new URL(arg0?.backgroundImageMobile?.imageUrl ?? arg0?.backgroundImage?.imageUrl, globalThis.location.origin);
        Object
            .entries(Object.assign({}, ImgDirective.QUERY_ENTRIES))
            .forEach(([key, value]) => {
                backgroundImageUrl.searchParams.set(key, value);
                backgroundImageMobileUrl.searchParams.set(key, value);
            });
        return [
            ImgDirective._sourceSet(backgroundImageMobileUrl, null, SettingsSetterDirective.SRCSET_SIZES.mobile ?? []),
            ImgDirective._sourceSet(backgroundImageUrl, null, SettingsSetterDirective.SRCSET_SIZES.desktopM ?? []),
        ]
            .join(',')
    }

    static SRCSET_SIZES = {
        mobile: ImgDirective.SIZES.filter(s => s < (768 * (globalThis?.devicePixelRatio ?? 1))),
        tablet: ImgDirective.SIZES.filter(s => s >= (768 * (globalThis?.devicePixelRatio ?? 1)) && s < (1024 * (globalThis?.devicePixelRatio ?? 1))),
        desktop: ImgDirective.SIZES.filter(s => s >= (1024 * (globalThis?.devicePixelRatio ?? 1))),
        desktopM: ImgDirective.SIZES.filter(s => s >= (768 * (globalThis?.devicePixelRatio ?? 1))),
    }
    static widthOptions = {
        1540: 'min(100%, 1540px)',
        1085: 'min(100%, 1085px)',
        900: 'min(100%, 900px)',
        600: 'min(100%, 600px)',
        400: 'min(100%, 400px)',
        200: 'min(100%, 400px)',
        unset: 'unset'
    };
    static backgroundSizes = [
        500,
        780,
        960,
        1920,
        3000,
    ];
    settings: GeneralElementSettings;

    @HostBinding('style.aspect-ratio')
    aspectRatio: string;

    @HostBinding('style.--color')
    color: string;

    @HostBinding('style.--background-color')
    backgroundColor: string;

    @HostBinding('style.justifyContent')
    position: string;

    @HostBinding('attr.id')
    id: string;

    @HostBinding('style.width')
    width: string;

    @HostBinding('style.margin')
    margin: string;

    @HostBinding('style.max-width')
    maxWidth: string;

    @HostBinding('style.padding')
    padding: string;

    @HostBinding('style.background')
    background: string;

    @HostBinding('style.background-attachment')
    attachment: string;

    @HostBinding('style.background-position')
    backgroundPosition: string;

    @HostBinding('style.background-size')
    backgroundSize: string;

    @HostBinding('style.height')
    backgroundheight: string;

    @HostBinding('style.overflow')
    overflow: string;

    @HostBinding('style.flex-wrap')
    flexWrap: string;

    @HostBinding('style.column-count')
    columnCount: number;

    @HostBinding('style.column-gap')
    columnGap: string;

    @HostBinding('style.column-width')
    columnWidth: string;

    @HostBinding('style.display')
    display: string;

    @HostBinding('attr.hideAt')
    hideAt: string;

    constructor(public elm: ElementRef, protected _detector: ChangeDetectorRef) {}


    ngAfterViewInit(): void {
    }

    ngOnInit() {
        if (this.settings == null) {
            this.settings = {};
            return;
        }

        if (this.settings.aspectRatio != null && this.settings.aspectRatio !== '') {
            this.aspectRatio = this.settings.aspectRatio;
        }
        Object.assign(this, SettingsSetterDirective.setColorSettings(this.settings));
        Object.assign(this, SettingsSetterDirective.setBoxSettings(this.settings));
        if ((this.settings?.hideAt ?? '')?.length > 0)
            this.hideAt = this.settings?.hideAt;
        //    Object.assign(this, SettingsSetterDirective.setBackgroundSettings(this));
        Object.assign(this, SettingsSetterDirective.setFontSettings(this.settings));
        Object.assign(this, SettingsSetterDirective.setPositionSettings(this.settings));
    }

    static setBackgroundSettings(_this: SettingsSetterDirective) {
        new Promise<void>((resolve, reject) => {
            setTimeout(() => {
                if (_this.settings.parallax) {
                    if (window.innerWidth > 1025) {
                        _this.attachment = 'fixed';
                        _this.backgroundheight = undefined;
                        _this.overflow = undefined;
                    } else {
                        _this.attachment = 'scroll !important';
                        _this.backgroundheight = '100%';
                        _this.overflow = 'hidden';
                    }
                } else {
                    _this.attachment = undefined;
                    _this.backgroundheight = undefined;
                    _this.overflow = undefined;
                }
                if (Guard.not.nullOrEmpty(_this.settings.backgroundImage)) {
                    const query = {};
                    try {
                        query['width'] = SettingsSetterDirective.backgroundSizes.reduce((prev, curr) => ((window?.devicePixelRatio ?? 1) * (_this.elm.nativeElement as HTMLElement).clientWidth) < prev ? prev : curr);

                    } catch {
                        query['width'] = 1200;
                    }

                    const backgroundImage = _this.settings.backgroundImage;
                    const url = backgroundImage['imageUrl'] != null ? backgroundImage['imageUrl'] : backgroundImage;

                    _this.background = `url(${ImageMapper.Url(url, query)})`;
                    _this.backgroundPosition = `${Math.floor(backgroundImage['focalPoint'].x * 100)}% ${Math.floor(backgroundImage['focalPoint'].y * 100)}%`;
                    _this.backgroundSize = 'cover';
                }
                _this._detector.markForCheck();
                resolve();
            }, 100);
        })
    }

    static setBoxSettings(settings: GeneralElementSettings) {
        var maxWidth = settings?.maxWidth ? SettingsSetterDirective.widthOptions[settings?.maxWidth] : null;
        var width = maxWidth == 'unset' ? 'unset' : null;

        var id = settings?.id;
        var margin = SettingsSetterDirective.mapAmountWithUnitNotRestricted(settings.margin) ?? 'auto';
        var padding = SettingsSetterDirective.mapAmountWithUnitNotRestricted(settings.padding) ?? 'auto';
        var flexWrap = '';
        if (settings.wrap) {
            flexWrap = 'wrap';
        }
        return { maxWidth, margin, padding, flexWrap, width, id };
    }

    static mapAmountWithUnit(value: string): string {
        if (value == null)
            return null;
        if (value.trim().length === 0 || value.startsWith('{'))
            return null;

        return value?.split(',')
            .map((val: string) => {
                if (!val.includes('-') && isNaN(+val))
                    return val;
                var min = 0,
                    variable = (+val) / 2380 * 100;
                if (val.includes('-'))
                    min = +val;
                else
                    min = +val / 2;
                return `clamp(min(${min}px, 100%), ${variable}vw, ${val}px)`
            })
            .join(` `);
    }
    static mapAmountWithUnitNotRestricted(value: string): string {
        if (value == null)
            return null;
        if (value.trim().length === 0 || value.startsWith('{'))
            return null;

        return value?.split(',')
            .map((val: string) => {
                if (!val.includes('-') && isNaN(+val))
                    return val;
                var min = 0,
                    variable = (+val) / 2380 * 100;
                if (val.includes('-'))
                    min = +val;
                else
                    min = +val / 2;
                return `clamp(${min}px, ${variable}vw, ${val}px)`
            })
            .join(` `);
    }

    static setColorSettings(settings: GeneralElementSettings) {
        return {
            color: settings?.colorTheme?.color,
            backgroundColor: settings?.colorTheme?.backgroundColor,
        }
    }

    static setFontSettings(settings: GeneralElementSettings) {
        return {
            columnCount: +settings?.columnCount > 0 ? settings?.columnCount : null,
            columnGap: SettingsSetterDirective.mapAmountWithUnitNotRestricted(settings?.columnGap),
            columnWidth: SettingsSetterDirective.mapAmountWithUnit(settings?.columnWidth),
            display: settings?.columnCount > 0 || +settings?.columnWidth > 0 ? 'block' : null,
        }
    }

    static setPositionSettings(settings: GeneralElementSettings) {
        var position = '';
        if (settings.position === 'right') {
            position = 'flex-end';
        } else {
            position = settings.position;
        }
        return { position }
    }
}
